import { keepPreviousData, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { fetchFeatureAudiences } from './api';
import { Audiences } from '../api-types/director';
import { UseQueryConfig } from '../query/types';

const FEATURE_QUERY_KEY_ROOT = 'featureFlags';

export function useFeaturesQuery(options?: UseQueryConfig<Audiences, Error>) {
  return useQuery({
    ...options,
    queryKey: [FEATURE_QUERY_KEY_ROOT],
    queryFn: () => fetchFeatureAudiences(),
    refetchInterval: 60 * 1000, // 1 minute
    placeholderData: keepPreviousData,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
  });
}

export function useFeaturesSuspenseQuery(options?: UseQueryConfig<Audiences, Error>) {
  return useSuspenseQuery({
    ...options,
    queryKey: [FEATURE_QUERY_KEY_ROOT],
    queryFn: () => fetchFeatureAudiences(),
    refetchInterval: 60 * 1000, // 1 minute
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
  });
}
